import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore/client';
import type { ZrmUserInfo } from '@zg-rentals/clickstream';

export const analytics = defineAnalytics({ CLICKSTREAM, COMSCORE });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');
export const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo>('CLICKSTREAM');
export const trackEvent = analytics.createTrackEvent<'CLICKSTREAM'>('CLICKSTREAM');
